"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1991,598],{

/***/ 11991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ features_company; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var company = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/lib/entities/fundachart.ts
var fundachart = __webpack_require__(4822);
// EXTERNAL MODULE: ./src/lib/entities/comparison.ts + 1 modules
var comparison = __webpack_require__(60913);
// EXTERNAL MODULE: ./src/features/company/slice.ts
var slice = __webpack_require__(90636);
// EXTERNAL MODULE: ./src/features/paywall/store/index.ts + 1 modules
var store = __webpack_require__(92182);
// EXTERNAL MODULE: ./src/features/paywall/constants.ts
var constants = __webpack_require__(11298);
// EXTERNAL MODULE: ./src/features/paywall/types.ts
var types = __webpack_require__(5072);
;// CONCATENATED MODULE: ./src/features/paywall/store/useErrorPaywall.ts








var ERROR = 402;
function useErrorPaywall(activeTab, symbol) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var error = (0,es/* useSelector */.v9)(fundachart/* selectors */.wl).error;
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), companyError = ref.error;
    var ref1 = (0,es/* useSelector */.v9)(comparison/* selectors */.wl), comparisonError = ref1.error;
    var resetProStatus = (0,store/* default */.Z)(function(state) {
        return state.resetProStatus;
    });
    (0,react.useEffect)(function() {
        if (!activeTab || !symbol) return;
        var TAB = activeTab.toUpperCase();
        switch(TAB){
            case constants/* CompanyWidgetEnum.FUNDACHART */.Uw.FUNDACHART:
                checkIsError(error);
                break;
            case constants/* CompanyWidgetEnum.SEASONALITY */.Uw.SEASONALITY:
            case constants/* CompanyWidgetEnum.FINANCIALS */.Uw.FINANCIALS:
                checkIsError(companyError);
                dispatch(slice/* default.actions.resetErrorState */.ZP.actions.resetErrorState());
                break;
            case constants/* CompanyWidgetEnum.COMPARISON */.Uw.COMPARISON:
                checkIsError(comparisonError);
                break;
            default:
                break;
        }
    }, [
        error,
        companyError,
        comparisonError,
        activeTab,
        symbol
    ]);
    var checkIsError = function(error) {
        var ref;
        if (!error) return false;
        var isError = ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === ERROR;
        if (isError) {
            resetProStatus(types/* SectionEnum.company */.P.company);
        }
        return true;
    };
    return {
        error: error,
        companyError: companyError,
        comparisonError: comparisonError
    };
}
/* harmony default export */ var store_useErrorPaywall = (useErrorPaywall);

;// CONCATENATED MODULE: ./src/features/paywall/store/useCompany.ts






function useCompany(activeTab, symbol) {
    var ref = (0,store/* default */.Z)(function(state) {
        return {
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, shallow/* default */.Z), getStatus = ref.getStatus, addCounter = ref.addCounter;
    store_useErrorPaywall(activeTab, symbol);
    var getFeatureByKey = function(key) {
        var KEY = key.toUpperCase();
        return constants/* PaywallFeatureEnum */.qU[KEY];
    };
    var companyGetStatus = function(key) {
        var feature = getFeatureByKey(key);
        if (!feature) return;
        getStatus({
            key: types/* SectionEnum.company */.P.company,
            feature: feature,
            company: symbol
        });
        addCounter({
            feature: feature,
            company: symbol
        });
    };
    var companyAddCounter = function(key) {
        var feature = getFeatureByKey(key);
        if (!feature) return;
        addCounter({
            feature: feature,
            company: symbol
        });
    };
    var getWidgetStatus = function() {
        var features = [
            constants/* PaywallFeatureEnum.ORDERBOOK */.qU.ORDERBOOK,
            constants/* PaywallFeatureEnum.RUNNING_TRADE */.qU.RUNNING_TRADE
        ];
        getStatus({
            key: types/* SectionEnum.company */.P.company,
            feature: features,
            company: symbol
        });
        // add counter for orderbook and running trade stream widget
        constants/* CompanyStreamWidget.forEach */.LB.forEach(function(key) {
            return companyAddCounter(key);
        });
    };
    (0,react.useEffect)(function() {
        if (!symbol) return;
        // undefined means the current tab is the stream tab
        if (activeTab === undefined) {
            getWidgetStatus();
            return;
        }
        if (!activeTab) return;
        companyGetStatus(activeTab);
    }, [
        activeTab,
        symbol
    ]);
    return {
        addCounter: function(key) {
            return companyAddCounter(key);
        }
    };
}
/* harmony default export */ var store_useCompany = (useCompany);

// EXTERNAL MODULE: ./src/global/Loading/PageLoader.jsx + 2 modules
var PageLoader = __webpack_require__(598);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./src/constants/clevertap.js
var constants_clevertap = __webpack_require__(92124);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/global/QueryProvider/index.tsx
var QueryProvider = __webpack_require__(62780);
// EXTERNAL MODULE: ./@types/company.d.ts
var company_d = __webpack_require__(82964);
// EXTERNAL MODULE: ./src/features/company/Navbar/index.tsx + 1 modules
var Navbar = __webpack_require__(67462);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/utils/company.ts
var utils_company = __webpack_require__(4168);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./src/global/Notation/IndicatorBar.tsx
var IndicatorBar = __webpack_require__(52491);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionBar.tsx
var CorpActionBar = __webpack_require__(88679);
// EXTERNAL MODULE: ./src/utils/tags.tsx + 2 modules
var tags = __webpack_require__(91601);
// EXTERNAL MODULE: ./src/global/Moderation/Modals/index.jsx + 7 modules
var Modals = __webpack_require__(31359);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/features/company/constants.ts
var company_constants = __webpack_require__(55564);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts + 1 modules
var useIsUserSyariah = __webpack_require__(66940);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/company/Header/styled.ts
var styled = __webpack_require__(50489);
// EXTERNAL MODULE: ./src/features/company/Header/FollowCompanyButton.tsx
var FollowCompanyButton = __webpack_require__(89238);
;// CONCATENATED MODULE: ./src/features/company/Header/index.tsx






















var cleanSymbol = utils_company/* default.cleanSymbol */.Z.cleanSymbol, isReksaDana = utils_company/* default.isReksaDana */.Z.isReksaDana;
var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var SymbolTag = ui/* Company.TagCompany.SymbolTag */.YD.TagCompany.SymbolTag;
var STATUS_LIST = {
    SUSPENDED: "STATUS_SUSPENDED",
    DELISTED: "STATUS_DELISTED"
};
function Header(param) {
    var _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, company = param.company, _isGuestCompany = param.isGuestCompany, isGuestCompany = _isGuestCompany === void 0 ? false : _isGuestCompany, onClickLink = param.onClickLink, onClickFollow = param.onClickFollow, onClickCorpAction = param.onClickCorpAction, onClickNotation = param.onClickNotation, onClickBuyButton = param.onClickBuyButton, onExpandToggle = param.onExpandToggle;
    var ref;
    var name = company.name, sector = company.sector, followers = company.followers, followed = company.followed, icon_url = company.icon_url, _country = company.country, country = _country === void 0 ? "ID" : _country, _notation = company.notation, notation = _notation === void 0 ? [] : _notation, uma = company.uma, _corp_action = company.corp_action, corp_action = _corp_action === void 0 ? {} : _corp_action, status = company.status, _catalogs = company.catalogs, catalogs = _catalogs === void 0 ? [] : _catalogs, exchange = company.exchange, _type_company = company.type_company, type_company = _type_company === void 0 ? "" : _type_company, id = company.id, tradeable = company.tradeable, dayTradeInfo = company.day_trade_info;
    var ref1 = dayTradeInfo || {}, multiplier = ref1.multiplier, isShowMultiplier = ref1.is_show_multiplier;
    var ref2 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref2.data;
    var tmp = profileData.country, profileCountry = tmp === void 0 ? "ID" : tmp;
    var ref3 = (0,react.useState)(!!icon_url), isIconAvailable = ref3[0], setIsIconAvailable = ref3[1];
    var ref4 = (0,react.useState)(false), isFollowerVisible = ref4[0], setIsFollowerVisible = ref4[1];
    var ref5 = (0,react.useState)(false), isFollowCompanyVisible = ref5[0], setIsFollowCompanyVisible = ref5[1];
    var ref6 = (0,react.useState)(!!followed), isFollowing = ref6[0], setIsFollowing = ref6[1];
    var isNotationAvailable = !!notation.length;
    var isCorpActionAvailable = corp_action === null || corp_action === void 0 ? void 0 : corp_action.active;
    var isSuspended = status === STATUS_LIST.SUSPENDED;
    var isDelisted = status === STATUS_LIST.DELISTED;
    var isCompanyStock = true;
    var isTradeable = tradeable === 1;
    var POPUP_COUNTRY_FLAG_TEXT = "This stock is traded on ".concat(exchange, " exchange");
    var buttonBuyRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var isUserSyariah = (0,useIsUserSyariah/* default */.Z)();
    var showMultiplier = (0,react.useMemo)(function() {
        return [
            parseInt(multiplier, 10) > 1,
            isShowMultiplier,
            !isUserSyariah
        ].every(Boolean);
    }, [
        multiplier,
        isShowMultiplier,
        isUserSyariah
    ]);
    // If not user Day Trade exclude catalog daytrade
    var filteredCatalogs = (0,react.useMemo)(function() {
        return catalogs.filter(function(param) {
            var company_symbol = param.company_symbol;
            return showMultiplier || (company_symbol === null || company_symbol === void 0 ? void 0 : company_symbol.toLowerCase()) !== "daytrade";
        });
    }, [
        catalogs,
        showMultiplier
    ]);
    var onImgError = function() {
        setIsIconAvailable(false);
    };
    var formattedCountry = country.toLowerCase();
    var IMAGE_URL = "/img/flags/".concat(formattedCountry, ".png");
    var generateCatalogUrl = function(itemSector, itemSubSector) {
        if (!itemSector) return "";
        if (sector && sector.toLowerCase() !== "indeks") {
            return "/catalog/".concat((0,general/* convertToSlug */.k6)(itemSector), "/").concat((0,general/* convertToSlug */.k6)(itemSubSector));
        }
        return "/catalog/".concat((0,general/* convertToSlug */.k6)(itemSubSector));
    };
    var onClickCatalogsLink = function(event, companySymbol) {
        if (isGuestCompany) {
            event.preventDefault();
            onClickLink(true);
        } else {
            (0,clevertap/* clevertapEvent */.Lq)("Company Action", {
                Action: "emiten_group",
                Group: companySymbol
            });
        }
    };
    var handleSuccessFollow = function(following) {
        setIsFollowing(following);
    };
    var handleToggleFollow = function(following) {
        if (isGuestCompany) {
            onClickFollow();
            return false;
        }
        handleSuccessFollow(following);
        return true;
    };
    var handleOpenModal = (0,react.useCallback)(function() {
        setIsFollowCompanyVisible(true);
    }, [
        isFollowCompanyVisible
    ]);
    var handleCancelModal = (0,react.useCallback)(function() {
        setIsFollowCompanyVisible(false);
    }, [
        isFollowCompanyVisible
    ]);
    var handleClickBuyButton = (0,react.useCallback)(function() {
        var ref;
        buttonBuyRef === null || buttonBuyRef === void 0 ? void 0 : (ref = buttonBuyRef.current) === null || ref === void 0 ? void 0 : ref.click();
    }, [
        buttonBuyRef
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.param) === null || ref1 === void 0 ? void 0 : ref1[0]) === company_constants/* TAB_LIST_NAME.BUY */.p.BUY) {
            handleClickBuyButton();
        }
    }, [
        handleClickBuyButton,
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.param
    ]);
    var renderCatalogsLink = function(catalogue) {
        var subSectorObject = {
            "Properti & Real Estate": "Properti dan Real Estate",
            Commodities: "Commodity"
        };
        var companySymbol = catalogue.catalog_name || catalogue.company_symbol;
        var companySymbolAlias = subSectorObject[companySymbol] || catalogue.company_symbol;
        var companyType = catalogue.company_type;
        var catalogUrl = "";
        switch(companyType){
            case "sub_sector":
                catalogUrl = generateCatalogUrl(sector, companySymbolAlias);
                break;
            case "listing-board":
                catalogUrl = generateCatalogUrl(companyType, (0,general/* convertToSlug */.k6)(companySymbolAlias));
                break;
            default:
                catalogUrl = "/catalog/".concat(companyType, "/").concat(companySymbolAlias);
                break;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: catalogUrl,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CatalogButton */.WW, {
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: function(e) {
                    return onClickCatalogsLink(e, companySymbol);
                },
                children: companySymbol
            })
        });
    };
    var renderSymbol = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Symbol */.mN, {
            children: cleanSymbol(symbol.toUpperCase())
        });
    };
    var renderCountryFlag = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CountryFlagContainer */.Hr, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                className: "desktop",
                placement: "top",
                title: POPUP_COUNTRY_FLAG_TEXT,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CountryFlag */.AW, {
                    src: IMAGE_URL,
                    alt: "".concat(country, " flag")
                }, "country-flag-desktop")
            })
        });
    };
    var renderCountryFlagMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CountryFlagContainerMobile */.vo, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CountryFlag */.AW, {
                className: "mobile",
                src: IMAGE_URL,
                alt: "".concat(country, " flag")
            }, "country-flag-mobile")
        });
    };
    var renderButtons = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonContainer */.qO, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FollowerWrapper */.E, {
                    as: "span",
                    onClick: function() {
                        return setIsFollowerVisible(true);
                    },
                    children: [
                        numeral_default()(followers).format("0,0"),
                        " followers"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowCompanyButton/* default */.Z, {
                    isFollowed: isFollowing,
                    onClick: handleOpenModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isTradeable && !isReksaDana(type_company) && profileCountry === "ID",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonBuy */.JQ, {
                        "data-cy": "company-buy-button",
                        onClick: onClickBuyButton,
                        ref: buttonBuyRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            weight: "bolder",
                            align: "center",
                            color: "inherit",
                            children: "Buy"
                        })
                    })
                })
            ]
        });
    };
    var renderButtonsMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonContainerMobile */.Y8, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FollowerWrapper */.E, {
                    as: "span",
                    onClick: function() {
                        return setIsFollowerVisible(true);
                    },
                    children: [
                        numeral_default()(followers).format("0,0"),
                        " followers"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowCompanyButton/* default */.Z, {
                    isFollowed: isFollowing,
                    onClick: handleOpenModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isTradeable && !isReksaDana(type_company) && profileCountry === "ID",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonBuy */.JQ, {
                        onClick: onClickBuyButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            weight: "bolder",
                            align: "center",
                            color: "inherit",
                            children: "Buy"
                        })
                    })
                })
            ]
        });
    };
    var renderCompanyLogo = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ImageWrapper */.fb, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    align: "center",
                    children: [
                        isIconAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "company-header-icon",
                            src: icon_url,
                            onError: onImgError,
                            alt: symbol,
                            width: "54px",
                            height: "54px"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImagePlaceholder */.Zc, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                children: !!symbol && symbol.toUpperCase().slice(0, 1)
                            })
                        }),
                        !!country && renderCountryFlagMobile()
                    ]
                }),
                renderButtonsMobile()
            ]
        });
    };
    var renderMultiplier = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* MultiplierContainer */.cF, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* MultiplierChip */.L$, {
                className: "multiplier-chip",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/day-trade/lightning-filled-company.svg",
                        alt: "",
                        height: "10",
                        width: "10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        size: "12px",
                        color: "#8277F8",
                        weight: "bold",
                        children: "".concat(multiplier, "x")
                    })
                ]
            })
        });
    };
    var renderNotationCorpActionBadges = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationContainer */.SD, {
            children: (0,tags/* renderTags */.a)({
                symbol: symbol,
                uma: uma,
                notation: notation,
                corp_action: corp_action,
                name: name
            })
        });
    };
    var renderSuspendedDelistedBadges = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isSuspended && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Badges */.a9, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Suspended"
                    })
                }),
                isDelisted && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Badges */.a9, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Delisted"
                    })
                })
            ]
        });
    };
    var renderCompanyName = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CompanyName */.zo, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: name
            })
        });
    };
    var renderCompanyTags = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CompanyTags */.cr, {
            children: filteredCatalogs.slice(0, 6).map(function(catalogue) {
                return catalogue.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "catalogs",
                    children: renderCatalogsLink(catalogue)
                }, catalogue.company_symbol);
            })
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ExpandButtonToggleMobile */.U7, {
            onExpand: onExpandToggle
        });
    };
    var renderNotationCorpActionBar = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* NotationCorpActionBarWrapper */.dF, {
            isCompanyStock: isCompanyStock,
            isBoth: isNotationAvailable && isCorpActionAvailable,
            children: [
                isNotationAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorBar/* default */.Z, {
                    symbol: symbol,
                    notation: notation,
                    uma: uma,
                    name: name,
                    isGuestCompanyStock: false,
                    onClick: onClickNotation
                }),
                isCorpActionAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionBar/* default */.Z, {
                    symbol: symbol,
                    corpAction: corp_action,
                    isGuestCompanyStock: false,
                    onClick: onClickCorpAction
                })
            ]
        });
    };
    // TODO: Should be fixed by SNE/V3 Rewrite
    var renderFollowerModal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalFollower */.ZZ, {
            symbol: symbol,
            companyId: id,
            visible: isFollowerVisible,
            onCancel: function() {
                return setIsFollowerVisible(false);
            }
        });
    };
    var renderFollowModal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalFollowing */.Mw, {
            visible: isFollowCompanyVisible,
            onCancel: handleCancelModal,
            companyId: id,
            onFollow: handleToggleFollow
        });
    };
    var renderCompanyHeader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyHeader */.ag, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyIdentity */.GT, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyInfoWrapper */.n4, {
                            $isIconAvailable: isIconAvailable,
                            children: [
                                renderCompanyLogo(),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyNameContainer */.Yu, {
                                    children: [
                                        renderSymbol(),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* NotationCountryFlagContainer */.gv, {
                                            children: [
                                                showMultiplier && renderMultiplier(),
                                                renderNotationCorpActionBadges(),
                                                !!country && renderCountryFlag(),
                                                renderSuspendedDelistedBadges()
                                            ]
                                        }),
                                        renderCompanyName(),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: profileCountry === "ID",
                                            children: renderCompanyTags()
                                        })
                                    ]
                                }),
                                renderExpandButtonToggle()
                            ]
                        }),
                        renderButtons()
                    ]
                }),
                renderNotationCorpActionBar(),
                renderFollowerModal(),
                renderFollowModal()
            ]
        });
    };
    return renderCompanyHeader();
}
/* harmony default export */ var company_Header = (Header);

// EXTERNAL MODULE: ./src/features/company/Chart/index.tsx + 3 modules
var Chart = __webpack_require__(82495);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePrice.ts
var useLivePrice = __webpack_require__(39767);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/utils.ts
var utils = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var AuthModal_constants = __webpack_require__(54855);
// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
;// CONCATENATED MODULE: ./src/features/company/Hero/hero.clevertap.ts

var clevertapOnChangeTimeframe = function(symbol, timeframe) {
    (0,clevertap/* clevertapEvent */.Lq)("company_action", {
        Action: "change_timeframe",
        Stock: symbol,
        Date: timeframe
    });
};
var clevertapOnClickChart = function(symbol) {
    (0,clevertap/* clevertapEvent */.Lq)("company_action", {
        Action: "chartbit",
        Stock: symbol,
        Source: "Chart"
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/company/Hero/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 20px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var HeroContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f339d886-0"
})(_templateObject(), ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro);

;// CONCATENATED MODULE: ./src/features/company/Hero/index.tsx























function Hero(param) {
    var symbol = param.symbol;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,es/* useSelector */.v9)(company/* selectors */.wl), _detail = ref.detail, detailCompany = _detail.data, _chart = ref.chart, chartCompany = _chart.data, isLoadingChart = _chart.isLoading;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref1.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref2 = (0,react.useState)(true), showMainChart = ref2[0], setShowMainChart = ref2[1];
    var ref3 = (0,react.useState)(false), loadingFollow = ref3[0], setLoadingFollow = ref3[1];
    var ref4 = (0,react.useState)(company_constants/* chartTimeframes.0.value */.Iv[0].value), timeframe = ref4[0], setTimeframe = ref4[1];
    var ref5 = (0,react.useState)({}), companyData = ref5[0], setCompanyData = ref5[1];
    var onExpandToggle = function() {
        return setShowMainChart(!showMainChart);
    };
    var currentCompany = (0,react.useMemo)(function() {
        return (detailCompany === null || detailCompany === void 0 ? void 0 : detailCompany[symbol]) || {};
    }, [
        detailCompany
    ]);
    var handleClickChart = (0,react.useCallback)(function() {
        return clevertapOnClickChart(symbol);
    }, [
        symbol
    ]);
    var handleSetTimeframe = (0,react.useCallback)(function(v) {
        setTimeframe(v);
        clevertapOnChangeTimeframe(symbol, v);
    }, [
        symbol,
        setTimeframe
    ]);
    var handleToggleFollow = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, watchlistId, data, action, follow;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = auth/* default.getUserAccess */.Z.getUserAccess(), watchlistId = ref.watchlist_id;
                        data = {
                            watchlistId: watchlistId,
                            companyId: currentCompany.id,
                            stateToUpdate: company/* STATE_DETAIL */._P
                        };
                        action = currentCompany.followed ? company/* effects.postUnfollowCompany */.Sz.postUnfollowCompany : company/* effects.postFollowCompany */.Sz.postFollowCompany;
                        setLoadingFollow(true);
                        _ctx.next = 6;
                        return dispatch(action(data));
                    case 6:
                        follow = _ctx.sent;
                        if (follow) {
                            setLoadingFollow(false);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleToggleFollow() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenCorpAction = function(e) {
        e.preventDefault();
        router.push("symbol/".concat(symbol, "/corpaction"));
    };
    var handleBuyButton = function() {
        return (0,maintenance/* withMaintenanceGuard */.L)(function() {
            (0,utils/* showTradingModalWithAuth */.Y)({
                symbol: symbol,
                orderType: AuthModal_constants/* AUTH_ORDER_TYPE.BUY */.q.BUY
            });
        });
    };
    (0,react.useEffect)(function() {
        if (timeframe && showMainChart) {
            var params = {
                symbol: symbol,
                timeframe: timeframe
            };
            dispatch(company/* effects.getCompanyChart */.Sz.getCompanyChart(params));
        }
    }, [
        dispatch,
        symbol,
        showMainChart,
        timeframe
    ]);
    (0,react.useEffect)(function() {
        if (detailCompany[symbol]) {
            setCompanyData(function(prevState) {
                return (0,_object_spread/* default */.Z)({}, prevState, detailCompany[symbol]);
            });
        }
    }, [
        detailCompany
    ]);
    var livePriceOnMessage = (0,react.useCallback)(function(param) {
        var date = param.date, lastprice = param.lastprice, change = param.change, percentage = param.percentage_change, volume = param.volume;
        setCompanyData(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                price: lastprice,
                change: change,
                percentage: percentage,
                volume: volume,
                time: moment_default()(date).format("ddd HH:mm")
            });
        });
    }, []);
    (0,useLivePrice/* useLivePrice */.L)([
        symbol
    ], liveprice_store_types/* LivePriceSymbolsKeyEnum.COMPANY_HERO */.j.COMPANY_HERO, "company", livePriceOnMessage);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Header, {
                symbol: symbol,
                company: currentCompany,
                isLoadingFollow: loadingFollow,
                onClickNotation: function() {},
                onClickFollow: handleToggleFollow,
                onClickCorpAction: handleOpenCorpAction,
                onClickBuyButton: handleBuyButton,
                onExpandToggle: onExpandToggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: country === "ID",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                    symbol: symbol,
                    company: companyData,
                    isLoadingChart: isLoadingChart,
                    chart: chartCompany === null || chartCompany === void 0 ? void 0 : chartCompany[symbol],
                    timeframe: timeframe,
                    isChartVisible: showMainChart,
                    onExpand: onExpandToggle,
                    onSelectTimeFrame: handleSetTimeframe,
                    onClickChart: handleClickChart
                })
            })
        ]
    });
}
/* harmony default export */ var company_Hero = (Hero);

;// CONCATENATED MODULE: ./src/features/company/index.clevertap.ts


var clevertapCompanyViewed = function(company) {
    var sectoralIndex = company.indexes_data.find(function(s) {
        return s.company_type === "indeks-sektoral";
    });
    var companyStatus = (0,general/* capitalizeFirstLetter */.fm)(company.status.replace("STATUS_", ""));
    var ref;
    var clevertapParams = {
        Symbol: company.symbol_2 || company.symbol,
        Name: company.name,
        Followers: company.followers,
        "Current Price": parseFloat(company.price),
        "Price Change": parseFloat(company.change),
        "Percentage Change": company.percentage,
        Exchange: company.exchange,
        "Asset Type": company.type_company,
        "Sectoral Index": (ref = sectoralIndex === null || sectoralIndex === void 0 ? void 0 : sectoralIndex.company_symbol) !== null && ref !== void 0 ? ref : "",
        Sector: company.sector,
        "Sub-Sector": company.sub_sector,
        "Is Watchlist Item": !!company.followed,
        "Is Corporate Action": !!company.corp_action.active,
        "Is Special Notation": !!company.notation.length,
        "Company Status": companyStatus
    };
    (0,clevertap/* clevertapEvent */.Lq)("Company Page Viewed", clevertapParams);
};

// EXTERNAL MODULE: ./src/features/company/store.ts
var company_store = __webpack_require__(26446);
;// CONCATENATED MODULE: ./src/features/company/index.tsx
























var NotFound = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9136).then(__webpack_require__.bind(__webpack_require__, 79136));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79136)
            ];
        }
    },
    ssr: false
});
var Stream = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7333), __webpack_require__.e(5406), __webpack_require__.e(6066), __webpack_require__.e(1279), __webpack_require__.e(1232), __webpack_require__.e(1066), __webpack_require__.e(2857), __webpack_require__.e(4089), __webpack_require__.e(4965), __webpack_require__.e(5880), __webpack_require__.e(2039)]).then(__webpack_require__.bind(__webpack_require__, 32039));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32039)
            ];
        }
    },
    ssr: false
});
var Insider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6796), __webpack_require__.e(8939)]).then(__webpack_require__.bind(__webpack_require__, 68939));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68939)
            ];
        }
    },
    ssr: false
});
var Seasonality = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6796), __webpack_require__.e(2144)]).then(__webpack_require__.bind(__webpack_require__, 92144));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92144)
            ];
        }
    },
    ssr: false
});
var Keystat = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6796), __webpack_require__.e(5830)]).then(__webpack_require__.bind(__webpack_require__, 65830));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65830)
            ];
        }
    },
    ssr: false
});
var Comparison = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4663), __webpack_require__.e(6796), __webpack_require__.e(743)]).then(__webpack_require__.bind(__webpack_require__, 40743));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40743)
            ];
        }
    },
    ssr: false
});
var Financial = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4663), __webpack_require__.e(6796), __webpack_require__.e(5841)]).then(__webpack_require__.bind(__webpack_require__, 35841));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35841)
            ];
        }
    },
    ssr: false
});
var Fundachart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3085), __webpack_require__.e(5520), __webpack_require__.e(9332), __webpack_require__.e(1677)]).then(__webpack_require__.bind(__webpack_require__, 81677));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81677)
            ];
        }
    },
    ssr: false
});
var Paywall = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6823).then(__webpack_require__.bind(__webpack_require__, 16823));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16823)
            ];
        }
    },
    ssr: false
});
var Analyst = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1757), __webpack_require__.e(2034), __webpack_require__.e(6796), __webpack_require__.e(9852), __webpack_require__.e(9682)]).then(__webpack_require__.bind(__webpack_require__, 29682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29682)
            ];
        }
    },
    ssr: false
});
var Profile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1524), __webpack_require__.e(4078), __webpack_require__.e(6796), __webpack_require__.e(3120), __webpack_require__.e(4625)]).then(__webpack_require__.bind(__webpack_require__, 12155));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12155)
            ];
        }
    },
    ssr: false
});
var Consensus = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6796), __webpack_require__.e(9852)]).then(__webpack_require__.bind(__webpack_require__, 19852));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19852)
            ];
        }
    },
    ssr: false
});
var CorpAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 96778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96778)
            ];
        }
    },
    ssr: false
});
var FRPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7292), __webpack_require__.e(9907)]).then(__webpack_require__.bind(__webpack_require__, 69907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69907)
            ];
        }
    },
    ssr: false
});
var COMPANY_SYMBOL_COMPONENTS = (0,_define_property/* default */.Z)({}, company_constants/* TAB_LIST_NAME.CONSENSUS */.p.CONSENSUS, Consensus);
var _obj;
var COMPANY_SYMBOL_PRO_COMPONENTS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.KEYSTATS */.p.KEYSTATS, Keystat), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.FINANCIALS */.p.FINANCIALS, Financial), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.FUNDACHART */.p.FUNDACHART, Fundachart), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.SEASONALITY */.p.SEASONALITY, Seasonality), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.COMPARISON */.p.COMPARISON, Comparison), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST, Analyst), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.INSIDER */.p.INSIDER, Insider), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.PROFILE */.p.PROFILE, Profile), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.CORP_ACTION_NEW_NAME */.p.CORP_ACTION_NEW_NAME, CorpAction), _obj);
function Company(param) {
    var symbol = param.symbol, tab = param.tab;
    var ref;
    var isLoaded = (0,useProtectedRoute/* default */.Z)().isLoaded;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _detail = ref1.detail, companyData = _detail.data, error = _detail.error;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var userId = data.id, country = data.country;
    var ref2 = (0,react.useState)(""), activeTab = ref2[0], setActiveTab = ref2[1];
    var setCompanyLoading = (0,company_store/* useCompanyStore */.J)(function(param) {
        var setLoading = param.setLoading;
        return setLoading;
    });
    var paywallTab = tab === company_constants/* TAB_LIST_NAME.BUY */.p.BUY ? undefined : tab;
    store_useCompany(paywallTab, symbol);
    (0,react.useEffect)(function() {
        setCompanyLoading(true);
        dispatch(slice/* default.actions.updateLoadingState */.ZP.actions.updateLoadingState({
            isLoading: true
        }));
    }, []);
    (0,react.useEffect)(function() {
        if (symbol) {
            var getCompanyDetail = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var ref, _payload, companyDetailError, companyDetailData;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return dispatch(company/* effects.getCompanyDetail */.Sz.getCompanyDetail(symbol));
                            case 2:
                                ref = _ctx.sent;
                                _payload = ref.// @ts-ignore
                                payload;
                                companyDetailError = _payload.error;
                                companyDetailData = _payload.data;
                                // @ts-ignore
                                if (!companyDetailError && companyDetailData) {
                                    clevertapCompanyViewed(companyDetailData);
                                }
                            case 7:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function getCompanyDetail() {
                    return _ref.apply(this, arguments);
                };
            }();
            getCompanyDetail();
        }
    }, [
        dispatch,
        symbol
    ]);
    (0,react.useEffect)(function() {
        if (tab) {
            setCompanyLoading(true);
            dispatch(slice/* default.actions.updateLoadingState */.ZP.actions.updateLoadingState({
                isLoading: true
            }));
            setActiveTab(tab);
        }
    }, [
        tab
    ]);
    if (!symbol || !companyData[symbol]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            ]
        });
    }
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {});
    }
    var currentCompany = companyData[symbol];
    var streamTabs = [
        company_constants/* TAB_LIST_NAME.HOME */.p.HOME,
        company_constants/* TAB_LIST_NAME.STREAM */.p.STREAM,
        company_constants/* TAB_LIST_NAME.NEWS */.p.NEWS,
        company_constants/* TAB_LIST_NAME.BUY */.p.BUY, 
    ];
    var proTabs = [
        company_constants/* TAB_LIST_NAME.FUNDACHART */.p.FUNDACHART,
        company_constants/* TAB_LIST_NAME.FINANCIALS */.p.FINANCIALS,
        company_constants/* TAB_LIST_NAME.KEYSTATS */.p.KEYSTATS,
        company_constants/* TAB_LIST_NAME.COMPARISON */.p.COMPARISON,
        company_constants/* TAB_LIST_NAME.SEASONALITY */.p.SEASONALITY,
        company_constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST,
        company_constants/* TAB_LIST_NAME.INSIDER */.p.INSIDER,
        company_constants/* TAB_LIST_NAME.PROFILE */.p.PROFILE,
        company_constants/* TAB_LIST_NAME.CORP_ACTION_NEW_NAME */.p.CORP_ACTION_NEW_NAME, 
    ];
    var tabs = ((ref = companyData[symbol]) === null || ref === void 0 ? void 0 : ref.tabs) || [];
    if (country === "MY" && tabs.length > 0) tabs = [
        "stream"
    ];
    var companyTabs = tabs.filter(function(value) {
        return value !== company_constants/* TAB_LIST_NAME.NEWS */.p.NEWS;
    }).map(function(value) {
        var newValue = value;
        if (value === company_constants/* TAB_ANALYST_NEW_NAME */.K1) {
            newValue = company_constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST;
        }
        return company_constants/* TAB_LIST */.YS[newValue];
    });
    var isTabsIncluded = function(tabList, name) {
        return Object.values(tabList).includes(name);
    };
    var renderTabContent = function(tabName) {
        var isPro = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var companySymbolComponentList = isPro ? COMPANY_SYMBOL_PRO_COMPONENTS : COMPANY_SYMBOL_COMPONENTS;
        var Component = companySymbolComponentList === null || companySymbolComponentList === void 0 ? void 0 : companySymbolComponentList[tabName];
        return Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
            symbol: symbol
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    var clevertapEventAction = function(name) {
        var ref, ref1, ref2, ref3, ref4;
        var clevertapEventActionEnum = company_d/* CompanyActionEnums */.F;
        var newName = name.toUpperCase();
        var action = clevertapEventActionEnum[newName];
        var isFCA = (ref = companyData[symbol]) === null || ref === void 0 ? void 0 : (ref1 = ref.notation) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
            return (item === null || item === void 0 ? void 0 : item.notation_code) === "X";
        });
        var notation = (ref2 = companyData[symbol]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.notation) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.notation_code;
        });
        var eventReturn = {
            eventName: constants_clevertap/* CLEVERTAP_EVENT_NAME.COMPANY_MENU */.dR.COMPANY_MENU,
            eventPayload: {
                Action: action,
                Stock: symbol,
                Company_Type: (ref4 = companyData[symbol]) === null || ref4 === void 0 ? void 0 : ref4.type_company,
                Is_FCA: isFCA
            }
        };
        if (notation.length > 0) {
            eventReturn.eventPayload.Special_Notation = notation.toString();
        }
        return eventReturn;
    };
    /**
   * Send CleverTap Event. "analyst" & "seasonality" event not same as the others.
   * @param {Object} eventParams
   * @param {
   * "analyst" | "stream" | "news" | "keystats" |
   * "financials" | "fundachart" | "seasonality" |
   * "chartbit" | "comparison" | "insider" | "profile" |
   * "corp.action"
   * } eventParams.tabPath Company Tab Name
   * @param {number} eventParams.timeout timeout before sending event in ms
   */ var sendCleverTapEvent = function(param) {
        var tabPath = param.tabPath, _timeout = param.timeout, timeout = _timeout === void 0 ? 0 : _timeout;
        var isStreamTabs = isTabsIncluded(streamTabs, tabPath);
        var newTabPath = isStreamTabs ? company_constants/* TAB_LIST_NAME.STREAM */.p.STREAM : tabPath;
        var ref = clevertapEventAction(newTabPath), eventName = ref.eventName, eventPayload = ref.eventPayload;
        if (newTabPath === company_constants/* TAB_LIST_NAME.CHARTBIT */.p.CHARTBIT) {
            eventPayload.Source = company_constants/* SOURCE_MENU */.R1;
        }
        setTimeout(function() {
            try {
                (0,clevertap/* clevertapEvent */.Lq)(eventName, eventPayload);
            } catch (_error) {
                console.error("Error sending CleverTap event");
            }
        }, timeout);
    };
    if ((currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.type_company) === "FR") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QueryProvider/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                    title: "".concat(currentCompany.symbol, " ").concat(currentCompany.name, " on Stockbit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                    loaded: isLoaded
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FRPage, {
                    symbol: symbol
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "".concat(currentCompany.symbol, " ").concat(currentCompany.name, " on Stockbit")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                loaded: isLoaded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Hero, {
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                tabs: companyTabs,
                active: activeTab,
                onSendClevertapEvent: sendCleverTapEvent,
                isLoggedIn: isLoggedIn,
                userId: userId,
                className: country.toLowerCase()
            }),
            isTabsIncluded(streamTabs, activeTab) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stream, {
                activeNav: activeTab,
                symbol: symbol
            }),
            isTabsIncluded(proTabs, activeTab) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paywall, {
                source: activeTab,
                symbol: symbol,
                children: renderTabContent(activeTab, true)
            }),
            renderTabContent(activeTab)
        ]
    });
}
/* harmony default export */ var features_company = (Company);


/***/ }),

/***/ 26446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCompanyStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14671);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);






var holdingCompositionInitialState = {
    data: {},
    error: {},
    isLoading: false
};
var corpActionInitialState = {};
// Initial State
var initialState = {
    profile: {},
    holdingComposition: holdingCompositionInitialState,
    corpAction: corpActionInitialState,
    consensus: {},
    insider: {},
    seasonality: {},
    keystat: {},
    financial: {},
    analyst: {},
    analystConsensus: {},
    isLoading: false,
    isLoadingAnalystConsensus: false,
    message: "",
    error: null,
    financialParams: {
        report: 1,
        statement: 1
    },
    pinnedPost: {
        data: {},
        isLoading: {},
        message: {},
        error: {}
    }
};
var companyActions = function(set) {
    return {
        setLoading: function(value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.isLoading = value;
                });
            });
        },
        getCompanyKeystat: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
                var getKeystat, _data, _$error, data, message;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading = true;
                                });
                            });
                            _ctx.next = 4;
                            return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyKeystat */ .Z.getCompanyKeystat(symbol);
                        case 4:
                            getKeystat = _ctx.sent;
                            if (getKeystat.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Attempt to get company keystat failed");
                        case 7:
                            _data = getKeystat.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 11;
                                break;
                            }
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.error = _$error;
                                    draft.message = message;
                                });
                            });
                            return _ctx.abrupt("return", {
                                error: _$error,
                                message: message
                            });
                        case 11:
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.keystat[symbol] = data;
                                });
                            });
                            return _ctx.abrupt("return", {
                                data: data,
                                symbol: symbol
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.error = _ctx.t0;
                                });
                            });
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                            _ctx.prev = 19;
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading = false;
                                });
                            });
                            return _ctx.finish(19);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15,
                        19,
                        22
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
var useCompanyStore = (0,zustand__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState, companyActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm.css)(_templateObject());
});
var Bouncer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Flex = ui/* Common.Flex */.Gn.Flex;
var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 56198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21671);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14229);




//  Utils

function useProtectedRoute() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .selectors */ .wl).isLoggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var token = utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .Z.getToken();
        if (!isLoggedIn && !(token === null || token === void 0 ? void 0 : (ref = token.accessToken) === null || ref === void 0 ? void 0 : ref.token)) {
            // @ts-ignore
            dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .effects.logout */ .Sz.logout());
            router.push("/login");
            return;
        }
        setIsLoaded(true);
    }, [
        dispatch,
        isLoggedIn,
        router
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProtectedRoute);


/***/ })

}]);